import React from "react";
import Typography from "@mui/material/Typography";

export default function Heading() {
  return (
    <div>
    <Typography variant="h3" 
    fontFamily="monospace"
    align="center">
      Mosaic Essay Writer
    </Typography>
    <Typography variant="h5" 
    fontFamily="monospace"
    align="center">
      Reimagine writing essays as paragraph blocks that can be moved around. Visualize an essay as a mosaic of ideas and images
    </Typography>
    </div>
  );
}
